import apiClient from '@u/apiClient'
import StatisticsExportController from '@/wayfinder/actions/App/Http/Controllers/AnalyticsDashboard/StatisticsExportController'
const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

function errorSuccessCallback(payload) {
  if (payload.errorCallback) {
    payload.errorCallback()
  }
}
export default {
  // region fetch
  async fetchStatisticsForExport({ commit }, payload) {
    await apiClient
      .route(
        StatisticsExportController.post({ stat: payload.id }),
        payload.element
      )
      .then(async (response) => {
        window.open(response.data.url)
        processSuccessCallback(payload)
      })
      .catch((reason) => {
        console.error('errors', reason)
        commit('auth/setErrors', reason.response, { root: true })
      })
  }
  // endregion
}
